import WorkCard from '@/components/base/WorkCard';
import SectionHeading from '@/components/base/SectionHeading';
import { works } from '@/mocks/works';
import { sortByUpdate } from '@/utils/works';

const LATEST_COUNT = 10;

export default function LatestUpdates() {
  const latest = sortByUpdate(works).slice(0, LATEST_COUNT);

  return (
    <section className="px-4 md:px-8 py-10 md:py-12">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="最新更新"
          subtitle="按更新时间倒序，第一时间掌握新剧热片"
          icon="ri-time-line"
          moreTo="/category/tv"
          moreLabel="进入频道"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {latest.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}